import React from "react";

function Main(props) {
  return (
    <>
      <main className="main">{props.children}</main>
    </>
  );
}

export default Main;
